"use client"

import React from "react"

const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = "7898461474"
    const message = "Hi, I have some queries..."
    const encodedMessage = encodeURIComponent(message)

    // Check if it's mobile device
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

    let whatsappUrl
    if (isMobile) {
      whatsappUrl = `whatsapp://send?phone=${phoneNumber}&text=${encodedMessage}`
    } else {
      whatsappUrl = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`
    }

    window.open(whatsappUrl, "_blank")
  }

  // WhatsApp icon SVG path - separated for cleaner code
  const whatsappIconPath = `
    M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164
    -.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059
    -.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52
    -.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372
    -.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 
    1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413
    -.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648
    -.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 
    9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 
    .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 
    0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.893 3.506z
  `
    .replace(/\s+/g, " ")
    .trim()

  const buttonStyles = `
    .whatsapp-button {
      position: fixed;
      left: 40px;
      top: 90%;
      transform: translateY(-50%);
      width: 60px;
      height: 60px;
      background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
      transition: all 0.3s ease;
      z-index: 1000;
      border: none;
      outline: none;
    }

    .whatsapp-button:hover {
      transform: translateY(-50%) scale(1.1);
      box-shadow: 0 6px 25px rgba(37, 211, 102, 0.6);
      background: linear-gradient(135deg, #128c7e 0%, #25d366 100%);
    }

    .whatsapp-button:active {
      transform: translateY(-50%) scale(0.95);
    }

    .whatsapp-icon {
      width: 32px;
      height: 32px;
      fill: white;
    }

    .whatsapp-button::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background: rgba(37, 211, 102, 0.3);
      animation: pulse 2s infinite;
    }

    @keyframes pulse {
      0% { transform: scale(1); opacity: 1; }
      70% { transform: scale(1.4); opacity: 0; }
      100% { transform: scale(1.4); opacity: 0; }
    }

    .tooltip {
      position: absolute;
      left: 70px;
      top: 50%;
      transform: translateY(-50%);
      background: #333;
      color: white;
      padding: 8px 12px;
      border-radius: 6px;
      font-size: 14px;
      white-space: nowrap;
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    }

    .tooltip::after {
      content: '';
      position: absolute;
      right: 100%;
      top: 50%;
      transform: translateY(-50%);
      border: 6px solid transparent;
      border-right-color: #333;
    }

    .whatsapp-button:hover .tooltip {
      opacity: 1;
      visibility: visible;
    }

    @media (max-width: 768px) {
      .whatsapp-button { width: 55px; height: 55px; left: 15px; }
      .whatsapp-icon { width: 28px; height: 28px; }
      .tooltip { display: none; }
    }

    @media (max-width: 480px) {
      .whatsapp-button { width: 50px; height: 50px; left: 10px; }
      .whatsapp-icon { width: 26px; height: 26px; }
    }
  `

  return React.createElement(
    React.Fragment,
    null,
    React.createElement("style", { jsx: "true" }, buttonStyles),
    React.createElement(
      "button",
      {
        className: "whatsapp-button",
        onClick: handleWhatsAppClick,
        "aria-label": "Contact us on WhatsApp",
        title: "Chat with us on WhatsApp",
      },
      React.createElement("div", { className: "tooltip" }, "Chat with us!"),
      React.createElement(
        "svg",
        {
          className: "whatsapp-icon",
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg",
        },
        React.createElement("path", { d: whatsappIconPath }),
      ),
    ),
  )
}

export default WhatsAppButton
